import React from "react";
import css from "./index.module.scss";
import classNames from "classnames";

// 静态收集图标资源，保证构建时被打包并输出到 static/svg 等目录。 / EN: File and image handling note.
const iconUrls = import.meta.glob<string>("../../assets/icons/*.{svg,png}", {
  eager: true,
  query: "?url",
  import: "default"
});

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  name?: string;
  size?: number | string;
  cursor?: React.CSSProperties["cursor"];
  alt?: string;
  type?: "svg" | "png";
}

const Icon: React.FC<IconProps> = ({ src, name, alt = "", type = "svg", cursor, size, style, className, ...reset }) => {
  const imgSrc = iconUrls[`../../assets/icons/${name}.${type}`];

  return src || imgSrc ? (
    <div className={classNames(css.icon, className)} style={{ width: size, height: size, cursor, ...style }}>
      <img src={src || imgSrc} alt={alt} {...reset} />
    </div>
  ) : null;
};

export default Icon;
